(function () {
  document.addEventListener(
    'click',
    function (e) {
      const minus = e.target.closest('quantity-selector .quantity-selector--minus');
      if (!minus) return;

      const selector = minus.closest('quantity-selector');
      if (!selector) return;

      const input = selector.querySelector('.quantity-selector--input');
      if (!input) return;

      const qty = parseInt(input.value || '1', 10);
      if (qty > 1) return;

      const cartItem = selector.closest('.cart--item');
      if (!cartItem) return;

      const line = Number(cartItem.getAttribute('data-line-num'));
      if (!line) return;

      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();

      cartItem.style.opacity = '0.45';
      cartItem.style.pointerEvents = 'none';

      fetch('/cart/change.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({
          line: line,
          quantity: 0
        })
      })
        .then(function (res) {
          return res.json();
        })
        .then(function (cart) {
          cartItem.style.transition = 'opacity .18s ease, height .22s ease, margin .22s ease, padding .22s ease';
          cartItem.style.height = cartItem.offsetHeight + 'px';
          cartItem.style.overflow = 'hidden';
          cartItem.style.opacity = '0';

          setTimeout(function () {
            cartItem.style.height = '0px';
            cartItem.style.marginTop = '0';
            cartItem.style.marginBottom = '0';
            cartItem.style.paddingTop = '0';
            cartItem.style.paddingBottom = '0';
          }, 20);

          setTimeout(function () {
            cartItem.remove();

            fetch(window.location.pathname + '?section_id=cart-drawer')
              .then(function (res) { return res.text(); })
              .then(function (html) {
                const doc = new DOMParser().parseFromString(html, 'text/html');
                const newCart = doc.querySelector('cart-element[data-view="drawer"]');
                const oldCart = document.querySelector('cart-element[data-view="drawer"]');

                if (newCart && oldCart) {
                  oldCart.innerHTML = newCart.innerHTML;
                }

                document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
                document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { cart: cart } }));
                window.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
                window.dispatchEvent(new CustomEvent('cart:refresh', { detail: { cart: cart } }));
              });
          }, 260);
        })
        .catch(function () {
          cartItem.style.opacity = '';
          cartItem.style.pointerEvents = '';
        });
    },
    true
  );
})();

(function () {
  document.addEventListener('click', function (e) {
    const btn = e.target.closest('[data-cross-sell-add]');
    if (!btn) return;

    e.preventDefault();
    e.stopPropagation();

    const form = btn.closest('[data-cross-sell]');
    if (!form) return;

    const variantId = form.getAttribute('data-variant-id');
    if (!variantId) return;

    btn.disabled = true;
    btn.classList.add('is-loading');

    fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({
        items: [{ id: Number(variantId), quantity: 1 }]
      })
    })
      .then(function (res) {
        return res.json();
      })
      .then(function () {
        return fetch(window.location.pathname + '?section_id=cart-drawer');
      })
      .then(function (res) {
        return res.text();
      })
      .then(function (html) {
        const doc = new DOMParser().parseFromString(html, 'text/html');

        const newCart = doc.querySelector('cart-element[data-view="drawer"]');
        const oldCart = document.querySelector('cart-element[data-view="drawer"]');

        if (newCart && oldCart) {
          oldCart.innerHTML = newCart.innerHTML;
        } else {
          document.dispatchEvent(new CustomEvent('cart:refresh'));
        }
      })
      .catch(function (err) {
        console.error('Cross sell add error:', err);
      })
      .finally(function () {
        btn.disabled = false;
        btn.classList.remove('is-loading');
      });
  }, true);
})();


/* CART DRAWER ANTI-FREEZE PATCH */
(function () {
  if (window.__RK_CART_ANTI_FREEZE_PATCH__) return;
  window.__RK_CART_ANTI_FREEZE_PATCH__ = true;

  function unlockDrawer() {
    document.body.style.overflow = '';
    document.documentElement.style.overflow = '';

    document.querySelectorAll(
      'cart-element[data-view="drawer"], cart-element[data-view="drawer"] .cart--form, [data-drawer-scroll-container]'
    ).forEach(function (el) {
      el.style.pointerEvents = '';
      el.style.touchAction = 'pan-y';
      el.style.overflowY = 'auto';
      el.style.webkitOverflowScrolling = 'touch';
    });
  }

  document.addEventListener('click', function () {
    setTimeout(unlockDrawer, 80);
    setTimeout(unlockDrawer, 300);
    setTimeout(unlockDrawer, 700);
  }, true);

  document.addEventListener('cart:updated', unlockDrawer);
  document.addEventListener('cart:refresh', unlockDrawer);
  window.addEventListener('cart:updated', unlockDrawer);
  window.addEventListener('cart:refresh', unlockDrawer);

  unlockDrawer();
})();